const validateHeaderItem = (menuItems = []) => {
  return menuItems?.filter((item) => {
    if (item?.fields?.uiComponent === 'Grid') {
      return item?.fields?.gridItems?.filter((subMenuItem) => subMenuItem)
    } else {
      return item
    }
  })
}

const validateFooterItem = (menuItems = []) => {
  return menuItems?.filter((item) => item)
}

export { validateFooterItem, validateHeaderItem }
